import Vue from 'vue'
import VueRouter from 'vue-router'
import LogIn from "@/components/LogIn.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'LogIn',
    component: LogIn
  },
  {
    path: '/registration/',
    name: 'Registration',
    component: () => import('@/components/Registration.vue')
  }, {
    path: '/fooldal',
    name: 'Main',
    component: () => import('@/components/Main.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
  // allowedForGuest: ['Login', 'Register']
})

export default router

